import appSettings from "../utils/AppSetting";
import useAxios from "../utils/UseAxios";

const TokenGateway = () => {
    const baseUrl = `${appSettings.services.TOKEN.apiUrl}`
  //   `${appSetting.services.warranty.apiUrl}`;
  // Additional headers if needed
  
  // Extract client ID and client secret from appSettings
    const { client_id, client_secret } = appSettings.services.Header;
  
  const { loading, error, get, post, put, del } = useAxios(baseUrl, {
    'Content-Type': 'x-www-form-urlencoded'
  });
  
    const GetToken = async (param) => {
      try {
        const response = await post(`/homeprooaprovider/oauth2/token`, param);
        return response;
      } catch (error) {
        console.error('Error posting data:', error);
        throw error;
      }
    };
  
    return {
      loading,
      error,
      GetToken,
    };
  };
  
  export default TokenGateway;